import rootReducer from './reducers';

import { createStore, applyMiddleware, compose } from 'redux';

const loggingMiddleware = (store) => (next) => (action) => {
	console.log(action);
	return next(action);
}

const middleware = [
	loggingMiddleware
];

export default compose(
    applyMiddleware(...middleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f
)(createStore)(rootReducer);



// WEBPACK FOOTER //
// ./src/store.js